import { useState } from 'react';
import { useTranslation } from 'react-i18next';
const useResourcesTypes = function () {
  let all = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  const {
    t
  } = useTranslation();
  const [value, setValue] = useState();
  if (!value) {
    setValue([{
      label: t('GENERAL.owner'),
      value: 'owner'
    }, {
      label: t('GENERAL.director'),
      value: 'director'
    }, {
      label: t('GENERAL.manager'),
      value: 'manager'
    }, {
      label: t('GENERAL.collaborator'),
      value: 'collaborator'
    }]);
  }
  if (!value && all) {
    setValue([{
      label: t('GENERAL.admin'),
      value: 'admin'
    }, {
      label: t('GENERAL.owner'),
      value: 'owner'
    }, {
      label: t('GENERAL.director'),
      value: 'director'
    }, {
      label: t('GENERAL.manager'),
      value: 'manager'
    }, {
      label: t('GENERAL.collaborator'),
      value: 'collaborator'
    }, {
      label: t('GENERAL.customer'),
      value: 'customer'
    }]);
  }
  return value;
};
export { useResourcesTypes };